import { VStack } from '../stack/VStack';
import styled from 'styled-components';

export const ScreenContainer = styled(VStack)`
  padding-right: 16px;
  padding-left: 16px;
  align-items: center;
  flex: 1;
`;
